import firebase from "firebase/app";
import { tBoutique, validate } from "tmt_api/src/types/types.validator";

export const documentRetailer = (id: string): firebase.firestore.DocumentReference<tBoutique> =>
  firebase
    .firestore()
    .collection("boutiques")
    .doc(id)
    .withConverter<tBoutique>({
      toFirestore: (data) => data,
      fromFirestore: (snapshot) => validate("tBoutique")(snapshot.data()),
    });

export const queryRetailers = (): firebase.firestore.Query<tBoutique> => {
  const collectionRef: firebase.firestore.Query = firebase.firestore().collection("boutiques");
  return collectionRef.withConverter<tBoutique>({
    toFirestore: (data) => data,
    fromFirestore: (snapshot) => validate("tBoutique")(snapshot.data()),
  });
};
